import { Children, type ComponentPropsWithoutRef, memo, type ReactNode } from 'react';

import { cn } from '@air/utils-tailwind';

export type FileStatusPanelItemProps = Pick<ComponentPropsWithoutRef<'button'>, 'className' | 'onClick'> & {
  title: ReactNode;
  subtitle?: ReactNode;
  avatar: ReactNode;
  buttons: ReactNode;
  previewLoader?: ReactNode;
};

export const FileStatusPanelItem = memo(
  ({ className, title, subtitle, avatar, buttons, previewLoader, onClick }: FileStatusPanelItemProps) => {
    const details = (
      <>
        {avatar}
        <div className="flex flex-1 flex-col justify-center">
          {title}
          {subtitle}
        </div>
      </>
    );
    const actionSlot = (
      <div className="pane-item-buttons flex shrink-0 items-center justify-end gap-2.5 pl-2.5">{buttons}</div>
    );
    const hasActionButtons = Children.toArray(buttons).length > 0;

    if (onClick && !hasActionButtons) {
      return (
        <button
          className={cn('flex w-full justify-between border-0 bg-transparent p-0 text-left text-inherit', className)}
          onClick={onClick}
          type="button"
        >
          {previewLoader}
          <div className="flex shrink">{details}</div>
          {actionSlot}
        </button>
      );
    }

    if (onClick) {
      return (
        <div className={cn('flex justify-between', className)}>
          {previewLoader}
          <button
            className="flex min-w-0 flex-1 cursor-pointer border-0 bg-transparent p-0 text-left text-inherit"
            onClick={onClick}
            type="button"
          >
            {details}
          </button>
          {actionSlot}
        </div>
      );
    }

    return (
      <div className={cn('flex justify-between', className)}>
        {previewLoader}
        <div className="flex shrink">{details}</div>
        {actionSlot}
      </div>
    );
  },
);

FileStatusPanelItem.displayName = 'FileStatusPanelItem';
